import { render } from "./SelectOrCreateAuthSecret.vue?vue&type=template&id=b4c8d426&scoped=true"
import script from "./SelectOrCreateAuthSecret.vue?vue&type=script&lang=js"
export * from "./SelectOrCreateAuthSecret.vue?vue&type=script&lang=js"

import "./SelectOrCreateAuthSecret.vue?vue&type=style&index=0&id=b4c8d426&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c8d426"]])

export default __exports__